import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { toggleModal } from '../Modal/modalActions';
import Modal from '../Modal/Modal';
import './UserMessage.scss';

const uniqueModalName = 'userMessage';

export class UserMessage extends Component {
    static propTypes = {
        onToggleModal: PropTypes.func.isRequired
    };

    render = () => {
        return (
            <Modal className="modal_container" uniqueModalName={uniqueModalName} title="Notification">
                <div className="emvio-user-message-modal">
                    <p className="user-message">
                        Effective October 1, 2026, Nexio will be making an update that will impact a small select
                        group of merchant accounts. As part of this change, affected merchants may notice a different
                        bank descriptor associated with deposits into their bank account.
                    </p>
                    <p className="user-message">
                        This change will not impact payment processing or the merchant&apos;s ability to receive
                        deposits, and no action is required.
                    </p>
                    <p className="user-message">
                        If you have any questions regarding a deposit or this change, please contact Nexio Customer
                        Support at support@nex.io or 801-623-4000.
                    </p>
                </div>
            </ Modal >
        );
    };
}

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        onToggleModal: () => dispatch(toggleModal(uniqueModalName))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserMessage);
